export default "__VITE_ASSET__CtCkOcDj__"